/* src/app/modules/concept/concept/booking-concept-sync-dialog.component.css */
.dlg-hdr {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px 14px;
  border-bottom: 1px solid #e5e7eb;
}
.dlg-hdr__title {
  display: flex;
  align-items: center;
  gap: 12px;
}
.dlg-hdr__icon-wrap {
  width: 40px;
  height: 40px;
  border-radius: 10px;
  background: rgba(227, 253, 100, .12);
  display: flex;
  align-items: center;
  justify-content: center;
}
.dlg-hdr__icon-wrap mat-icon {
  font-size: 22px;
  width: 22px;
  height: 22px;
  color: #e3fd64;
}
.dlg-hdr__title > div > span {
  display: block;
  font-size: 15px;
  font-weight: 700;
  color: #1a1d23;
}
.dlg-hdr__sub {
  display: block;
  font-size: 12px;
  color: #6b7280;
}
.dlg-hdr__close {
  color: #6b7280;
}
.dlg-body {
  padding: 24px 24px 8px !important;
  max-height: 70vh;
  overflow-y: auto;
}
.dlg-actions {
  padding: 12px 20px !important;
  border-top: 1px solid #e5e7eb;
  gap: 8px;
}
.dlg-btn-save {
  background-color: #e3fd64 !important;
  color: rgba(0, 0, 0, .85) !important;
  font-weight: 600 !important;
  border-radius: 8px !important;
  display: flex;
  align-items: center;
  gap: 6px;
}
.bccs-loading {
  display: flex;
  justify-content: center;
  padding: 40px 0;
}
.bccs-error {
  color: #dc2626;
  font-size: 13px;
  padding: 8px 0 12px;
}
.bccs-section-label {
  font-size: 11px;
  font-weight: 700;
  color: #aaa;
  text-transform: uppercase;
  letter-spacing: .8px;
  margin: 20px 0 10px;
}
.bccs-section-label:first-of-type {
  margin-top: 0;
}
.bccs-compare-grid {
  display: grid;
  grid-template-columns: 1fr 40px 1fr;
  align-items: center;
  column-gap: 8px;
}
.bccs-col-hdr {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
  font-weight: 600;
  color: #555;
  padding-bottom: 10px;
  border-bottom: 2px solid #f0f0f0;
}
.bccs-col-hdr-mid {
  padding-bottom: 10px;
  border-bottom: 2px solid #f0f0f0;
}
.bccs-icon {
  font-size: 16px;
  width: 16px;
  height: 16px;
}
.bccs-icon--factu {
  color: #e3fd64;
}
.bccs-icon--bookcit {
  color: #2196f3;
}
.bccs-cell {
  min-width: 0;
}
.bccs-field {
  width: 100%;
}
.bccs-arrows {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.bccs-arrow-btn {
  color: #ccc !important;
  width: 28px !important;
  height: 28px !important;
  line-height: 28px !important;
}
.bccs-arrow-btn:hover {
  color: #e3fd64 !important;
}
.bccs-arrow-btn mat-icon {
  font-size: 20px;
  width: 20px;
  height: 20px;
  line-height: 20px;
}
.bccs-euro-suffix {
  font-size: 14px;
  color: #9ca3af;
  font-weight: 500;
  margin-right: 6px;
}
.bccs-locations {
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 4px 0;
}
.bccs-empty {
  color: #999;
  font-size: 14px;
  padding: 12px 0;
}
/*# sourceMappingURL=booking-concept-sync-dialog.component.css.map */
